import { authApiCall } from "../../auth";

export const getPointsRequests = (business) => {
  return authApiCall({
    url: `/points/retrieve-requests/?business=${business}`,
    method: 'get',
  });
};
